// @flow

// TODO: should be moved to GQL resolver side
export default function getStatusText(status: string): any {
  const statuses = {
    all: I18n.t('projects.my_projects.statuses.all'),
    archived: I18n.t('work_item.statuses.archived'),
    cancelled: I18n.t('work_item.statuses.cancelled'),
    completed: I18n.t('work_item.statuses.completed'),
    current: I18n.t('work_item.statuses.current'),
    done: I18n.t('work_item.statuses.completed'),
    future: I18n.t('work_item.statuses.someday'),
    scheduled: I18n.t('work_item.statuses.scheduled'),
    someday: I18n.t('work_item.statuses.someday'),
    waiting: I18n.t('work_item.statuses.waiting'),
  }

  return statuses[status.toLowerCase()] || ''
}
